import * as React from 'react';

type Props = {
    value: number;
    type: number;
    onChange: (value: { value: number, type: number }) => void;
};

type State = {

}

export default class WeightInput extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.getValue = this.getValue.bind(this);
        this.getTypeName = this.getTypeName.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
    }

    public render() {
        return <React.Fragment>
            <input
                className="form-control"
                type="number"
                min={0}
                value={this.getValue()}
                onChange={(e) => this.onChangeValue(e.target.value)}
            />
            <div className="input-group-append">
                <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.getTypeName()}</button>
                <div className="dropdown-menu">
                    <button type="button" className="dropdown-item" onClick={() => this.onChangeType(0)}>Kilograms</button>
                    <button type="button" className="dropdown-item" onClick={() => this.onChangeType(1)}>Pounds</button>
                </div>
            </div>
        </React.Fragment>
    }

    private onChangeValue(value: string) {
        let parsedValue = parseInt(value) || 0;
        if (this.props.type === 1) {
            parsedValue = parsedValue * 0.453592;
        }
        this.props.onChange({ value: parsedValue, type: this.props.type });
    }

    private onChangeType(type: 0|1) {
        this.props.onChange({ value: this.props.value, type });
    }

    private getValue() {
        switch(this.props.type) {
            case 1:
                return Math.round(this.props.value * 2.20462);
            default:
                return Math.round(this.props.value);
        }
    }

    private getTypeName() {
        switch(this.props.type) {
            case 0:
                return "Kilograms";
            case 1:
                return "Pounds";
            default:
                throw "Invalid Weight Type!";
        }
    }
}
